/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const pdfProcessSend = /* GraphQL */ `
  query PdfProcessSend(
    $jobId: ID!
    $pdfType: String!
    $pdfName: String!
    $subject: String!
    $body: String!
    $to: [String]!
    $from: String!
  ) {
    pdfProcessSend(
      jobId: $jobId
      pdfType: $pdfType
      pdfName: $pdfName
      subject: $subject
      body: $body
      to: $to
      from: $from
    )
  }
`;
export const pdfView = /* GraphQL */ `
  query PdfView($jobId: ID!, $pdfType: String!, $pdfName: String!) {
    pdfView(jobId: $jobId, pdfType: $pdfType, pdfName: $pdfName)
  }
`;
export const nextJobNr = /* GraphQL */ `
  query NextJobNr {
    nextJobNr
  }
`;
export const toggleUserEnabled = /* GraphQL */ `
  query ToggleUserEnabled($username: String!, $enabled: Boolean!) {
    toggleUserEnabled(username: $username, enabled: $enabled)
  }
`;
export const createGroup = /* GraphQL */ `
  query CreateGroup($groupName: String!, $description: String!) {
    createGroup(groupName: $groupName, description: $description)
  }
`;
export const signUpUser = /* GraphQL */ `
  query SignUpUser(
    $username: String!
    $password: String!
    $email: String!
    $groups: [String]
  ) {
    signUpUser(
      username: $username
      password: $password
      email: $email
      groups: $groups
    )
  }
`;
export const listUsersInGroup = /* GraphQL */ `
  query ListUsersInGroup($groupName: String!) {
    listUsersInGroup(groupName: $groupName)
  }
`;
export const supplierEvent = /* GraphQL */ `
  query SupplierEvent($subject: String!, $message: String!) {
    supplierEvent(subject: $subject, message: $message)
  }
`;
export const clientEvent = /* GraphQL */ `
  query ClientEvent($subject: String!, $message: String!) {
    clientEvent(subject: $subject, message: $message)
  }
`;
export const getNote = /* GraphQL */ `
  query GetNote($id: ID!) {
    getNote(id: $id) {
      id
      createdAt
      updatedAt
      note
      tags
      followUp
      owner
      job {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
    }
  }
`;
export const listNotes = /* GraphQL */ `
  query ListNotes(
    $filter: ModelNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        updatedAt
        note
        tags
        followUp
        owner
        job {
          id
          jobNr
          jobClientId
          jobSupplierId
          startDate
          dueDate
          clientRef
          name
          description
          closed
          priority
          clientOrderNumber
          contact1
          contact2
          product
          quantity
          product2
          quantity2
          licenseNr
          serviceAgent
          phone
          mobile
          fax
          other
          email
          address
          townSuburb
          state
          postcode
          proofOfPurchase
          datePurchased
          purchasedFrom
          builderInstall
          contactNr
          finalKpa
          status
          faultInformation
          checklist
          inspect
          partsToCustomer
          photosRequired
          pickup
          service
          vanStock
          followUp
          completionNote
        }
      }
      nextToken
    }
  }
`;
export const getClient = /* GraphQL */ `
  query GetClient($id: ID!) {
    getClient(id: $id) {
      id
      title
      address
      suburb
      state
      postcode
      mainContact
      phone
      fax
      mobile
      email
      sendBy
      serviceCallNotes
      jobs {
        items {
          id
          jobNr
          jobClientId
          jobSupplierId
          startDate
          dueDate
          clientRef
          name
          description
          closed
          priority
          clientOrderNumber
          contact1
          contact2
          product
          quantity
          product2
          quantity2
          licenseNr
          serviceAgent
          phone
          mobile
          fax
          other
          email
          address
          townSuburb
          state
          postcode
          proofOfPurchase
          datePurchased
          purchasedFrom
          builderInstall
          contactNr
          finalKpa
          status
          faultInformation
          checklist
          inspect
          partsToCustomer
          photosRequired
          pickup
          service
          vanStock
          followUp
          completionNote
        }
        nextToken
      }
      contacts {
        items {
          id
          name
          position
          phone
          mobile
          fax
          email
          contactClientId
          deactivated
        }
        nextToken
      }
      products {
        items {
          id
          title
          productClientId
        }
        nextToken
      }
    }
  }
`;
export const listClients = /* GraphQL */ `
  query ListClients(
    $filter: ModelClientFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listClients(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        address
        suburb
        state
        postcode
        mainContact
        phone
        fax
        mobile
        email
        sendBy
        serviceCallNotes
        jobs {
          nextToken
        }
        contacts {
          nextToken
        }
        products {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getSupplier = /* GraphQL */ `
  query GetSupplier($id: ID!) {
    getSupplier(id: $id) {
      id
      title
      dateCreated
      address
      suburb
      state
      postcode
      mainContact
      phone
      fax
      mobile
      email
      deliveryAddress
      deliverySuburb
      deliveryState
      deliveryPostcode
      notes
      jobsSentBy
      agreementReturned
      insuranceExpires
      # ratePerHour
      username
      password
      postcodes
      jobs {
        items {
          id
          jobNr
          jobClientId
          jobSupplierId
          startDate
          dueDate
          clientRef
          name
          description
          closed
          priority
          clientOrderNumber
          contact1
          contact2
          product
          quantity
          product2
          quantity2
          licenseNr
          serviceAgent
          phone
          mobile
          fax
          other
          email
          address
          townSuburb
          state
          postcode
          proofOfPurchase
          datePurchased
          purchasedFrom
          builderInstall
          contactNr
          finalKpa
          status
          faultInformation
          checklist
          inspect
          partsToCustomer
          photosRequired
          pickup
          service
          vanStock
          followUp
          completionNote
        }
        nextToken
      }
      deactivated
    }
  }
`;
export const listSuppliers = /* GraphQL */ `
  query ListSuppliers(
    $filter: ModelSupplierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSuppliers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        dateCreated
        address
        suburb
        state
        postcode
        mainContact
        phone
        fax
        mobile
        email
        deliveryAddress
        deliverySuburb
        deliveryState
        deliveryPostcode
        notes
        jobsSentBy
        agreementReturned
        insuranceExpires
        # ratePerHour
        username
        password
        postcodes
        jobs {
          nextToken
        }
        deactivated
      }
      nextToken
    }
  }
`;
export const getJob = /* GraphQL */ `
  query GetJob($id: ID!) {
    getJob(id: $id) {
      id
      jobNr
      jobNotes {
        items {
          id
          createdAt
          updatedAt
          note
          tags
          followUp
          owner
          sharedWith
        }
        nextToken
      }
      notes {
        items {
          id
          createdAt
          updatedAt
          note
          tags
          followUp
          owner
        }
        nextToken
      }
      sharedNotes {
        items {
          id
          createdAt
          updatedAt
          note
          tags
          followUp
          owner
        }
        nextToken
      }
      parts {
        items {
          id
          dateOrdered
          quantity
          partOrdered
        }
        nextToken
      }
      client {
        id
        title
        address
        suburb
        state
        postcode
        mainContact
        phone
        fax
        mobile
        email
        sendBy
        serviceCallNotes
        jobs {
          nextToken
        }
        contacts {
          nextToken
        }
        products {
          nextToken
        }
      }
      jobClientId
      # supplier {
        # id
        # title
        # dateCreated
        # address
        # suburb
        # state
        # postcode
        # mainContact
        # phone
        # fax
        # mobile
        # email
        # deliveryAddress
        # deliverySuburb
        # deliveryState
        # deliveryPostcode
        # notes
        # jobsSentBy
        # agreementReturned
        # insuranceExpires
        # # ratePerHour
        # username
        # password
        # postcodes
        # jobs {
          # nextToken
        # }
        # deactivated
      # }
      jobSupplierId
      startDate
      dueDate
      clientRef
      name
      description
      closed
      priority
      clientOrderNumber
      contact1
      contact2
      product
      quantity
      product2
      quantity2
      licenseNr
      serviceAgent
      phone
      mobile
      fax
      other
      email
      address
      townSuburb
      state
      postcode
      proofOfPurchase
      datePurchased
      purchasedFrom
      builderInstall
      contactNr
      finalKpa
      status
      faultInformation
      checklist
      inspect
      partsToCustomer
      photosRequired
      pickup
      service
      vanStock
      followUp
      completionNote
      supplierTitle
    }
  }
`;
export const listJobs = /* GraphQL */ `
  query ListJobs(
    $filter: ModelJobFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJobs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
      nextToken
    }
  }
`;
export const getJobStatus = /* GraphQL */ `
  query GetJobStatus($id: ID!) {
    getJobStatus(id: $id) {
      id
      title
      bgColor
      fgColor
      completesJob
    }
  }
`;
export const listJobStatuss = /* GraphQL */ `
  query ListJobStatuss(
    $filter: ModelJobStatusFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJobStatuss(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        bgColor
        fgColor
        completesJob
      }
      nextToken
    }
  }
`;
export const getJobPriority = /* GraphQL */ `
  query GetJobPriority($id: ID!) {
    getJobPriority(id: $id) {
      id
      title
      deactivated
    }
  }
`;
export const listJobPrioritys = /* GraphQL */ `
  query ListJobPrioritys(
    $filter: ModelJobPriorityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJobPrioritys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        deactivated
      }
      nextToken
    }
  }
`;
export const getJobFaultType = /* GraphQL */ `
  query GetJobFaultType($id: ID!) {
    getJobFaultType(id: $id) {
      id
      title
      deactivated
    }
  }
`;
export const listJobFaultTypes = /* GraphQL */ `
  query ListJobFaultTypes(
    $filter: ModelJobFaultTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJobFaultTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        deactivated
      }
      nextToken
    }
  }
`;
export const getNoteContactType = /* GraphQL */ `
  query GetNoteContactType($id: ID!) {
    getNoteContactType(id: $id) {
      id
      title
      deactivated
    }
  }
`;
export const listNoteContactTypes = /* GraphQL */ `
  query ListNoteContactTypes(
    $filter: ModelNoteContactTypeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNoteContactTypes(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        deactivated
      }
      nextToken
    }
  }
`;
export const getJobAction = /* GraphQL */ `
  query GetJobAction($id: ID!) {
    getJobAction(id: $id) {
      id
      jobId
      createdAt
      updatedAt
      action
      owner
      job {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
    }
  }
`;
export const listJobActions = /* GraphQL */ `
  query ListJobActions(
    $filter: ModelJobActionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJobActions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        jobId
        createdAt
        updatedAt
        action
        owner
        job {
          id
          jobNr
          jobClientId
          jobSupplierId
          startDate
          dueDate
          clientRef
          name
          description
          closed
          priority
          clientOrderNumber
          contact1
          contact2
          product
          quantity
          product2
          quantity2
          licenseNr
          serviceAgent
          phone
          mobile
          fax
          other
          email
          address
          townSuburb
          state
          postcode
          proofOfPurchase
          datePurchased
          purchasedFrom
          builderInstall
          contactNr
          finalKpa
          status
          faultInformation
          checklist
          inspect
          partsToCustomer
          photosRequired
          pickup
          service
          vanStock
          followUp
          completionNote
        }
      }
      nextToken
    }
  }
`;
export const getInvoice = /* GraphQL */ `
  query GetInvoice($id: ID!) {
    getInvoice(id: $id) {
      id
      jobId
      createdAt
      updatedAt
      owner
      job {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
      # supplier {
        # id
        # title
        # dateCreated
        # address
        # suburb
        # state
        # postcode
        # mainContact
        # phone
        # fax
        # mobile
        # email
        # deliveryAddress
        # deliverySuburb
        # deliveryState
        # deliveryPostcode
        # notes
        # jobsSentBy
        # agreementReturned
        # insuranceExpires
        # # ratePerHour
        # username
        # password
        # postcodes
        # jobs {
          # nextToken
        # }
        # deactivated
      # }
      invoiceNumber
      description
      amount
      clientAmount
      clientInvoiced
      t2InvoiceNumber
      t2Invoiced
    }
  }
`;
export const listInvoices = /* GraphQL */ `
  query ListInvoices(
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listInvoices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        jobId
        createdAt
        updatedAt
        owner
        job {
          id
          jobNr
          jobClientId
          jobSupplierId
          startDate
          dueDate
          clientRef
          name
          description
          closed
          priority
          clientOrderNumber
          contact1
          contact2
          product
          quantity
          product2
          quantity2
          licenseNr
          serviceAgent
          phone
          mobile
          fax
          other
          email
          address
          townSuburb
          state
          postcode
          proofOfPurchase
          datePurchased
          purchasedFrom
          builderInstall
          contactNr
          finalKpa
          status
          faultInformation
          checklist
          inspect
          partsToCustomer
          photosRequired
          pickup
          service
          vanStock
          followUp
          completionNote
        }
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        invoiceNumber
        description
        amount
        clientAmount
        clientInvoiced
        t2InvoiceNumber
        t2Invoiced
      }
      nextToken
    }
  }
`;
export const contactsByClientId = /* GraphQL */ `
  query ContactsByClientId(
    $contactClientId: ID
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelContactFilterInput
    $limit: Int
    $nextToken: String
  ) {
    contactsByClientId(
      contactClientId: $contactClientId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        position
        phone
        mobile
        fax
        email
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        contactClientId
        deactivated
      }
      nextToken
    }
  }
`;
export const productsByClientId = /* GraphQL */ `
  query ProductsByClientId(
    $productClientId: ID
    $title: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    productsByClientId(
      productClientId: $productClientId
      title: $title
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        productClientId
      }
      nextToken
    }
  }
`;
export const byJobIdCreatedAt = /* GraphQL */ `
  query ByJobIdCreatedAt(
    $jobId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelJobActionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    byJobIdCreatedAt(
      jobId: $jobId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        jobId
        createdAt
        updatedAt
        action
        owner
        job {
          id
          jobNr
          jobClientId
          jobSupplierId
          startDate
          dueDate
          clientRef
          name
          description
          closed
          priority
          clientOrderNumber
          contact1
          contact2
          product
          quantity
          product2
          quantity2
          licenseNr
          serviceAgent
          phone
          mobile
          fax
          other
          email
          address
          townSuburb
          state
          postcode
          proofOfPurchase
          datePurchased
          purchasedFrom
          builderInstall
          contactNr
          finalKpa
          status
          faultInformation
          checklist
          inspect
          partsToCustomer
          photosRequired
          pickup
          service
          vanStock
          followUp
          completionNote
        }
      }
      nextToken
    }
  }
`;
export const invoicesByJobIdCreatedAt = /* GraphQL */ `
  query InvoicesByJobIdCreatedAt(
    $jobId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelInvoiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    invoicesByJobIdCreatedAt(
      jobId: $jobId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        jobId
        createdAt
        updatedAt
        owner
        job {
          id
          jobNr
          jobClientId
          jobSupplierId
          startDate
          dueDate
          clientRef
          name
          description
          closed
          priority
          clientOrderNumber
          contact1
          contact2
          product
          quantity
          product2
          quantity2
          licenseNr
          serviceAgent
          phone
          mobile
          fax
          other
          email
          address
          townSuburb
          state
          postcode
          proofOfPurchase
          datePurchased
          purchasedFrom
          builderInstall
          contactNr
          finalKpa
          status
          faultInformation
          checklist
          inspect
          partsToCustomer
          photosRequired
          pickup
          service
          vanStock
          followUp
          completionNote
        }
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        invoiceNumber
        description
        amount
        clientAmount
        clientInvoiced
        t2InvoiceNumber
        t2Invoiced
      }
      nextToken
    }
  }
`;
export const searchJobs = /* GraphQL */ `
  query SearchJobs(
    $filter: SearchableJobFilterInput
    $sort: SearchableJobSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchJobs(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        jobNr
        jobNotes {
          nextToken
        }
        notes {
          nextToken
        }
        sharedNotes {
          nextToken
        }
        parts {
          nextToken
        }
        client {
          id
          title
          address
          suburb
          state
          postcode
          mainContact
          phone
          fax
          mobile
          email
          sendBy
          serviceCallNotes
        }
        jobClientId
        # supplier {
          # id
          # title
          # dateCreated
          # address
          # suburb
          # state
          # postcode
          # mainContact
          # phone
          # fax
          # mobile
          # email
          # deliveryAddress
          # deliverySuburb
          # deliveryState
          # deliveryPostcode
          # notes
          # jobsSentBy
          # agreementReturned
          # insuranceExpires
          # # ratePerHour
          # username
          # password
          # postcodes
          # deactivated
        # }
        jobSupplierId
        startDate
        dueDate
        clientRef
        name
        description
        closed
        priority
        clientOrderNumber
        contact1
        contact2
        product
        quantity
        product2
        quantity2
        licenseNr
        serviceAgent
        phone
        mobile
        fax
        other
        email
        address
        townSuburb
        state
        postcode
        proofOfPurchase
        datePurchased
        purchasedFrom
        builderInstall
        contactNr
        finalKpa
        status
        faultInformation
        checklist
        inspect
        partsToCustomer
        photosRequired
        pickup
        service
        vanStock
        followUp
        completionNote
      }
      nextToken
      total
    }
  }
`;
